import HTTP from "./http.service";
import Storage from "./storage.service";
import { exclude_vat } from "./vat.services";
import Helpers from "./helpers";
import Settings from "./settings";

const getInstallmentsDetails = (data) => {
    let config = {
		method: "get",
		url: "/payments/instalment_timeline.json",
        params: data
	};
	return HTTP(config);
}

const checkInstalmentsEligibility = (plan) => {
	// check if installments disabled from bussiness config:
	if (Storage.get("businessConfig")?.show_instalments_available_label === false) {
		return false;
	}
	if (!plan) plan = Storage.get("saved_plan");
	return plan?.PackageEligibility?.includes('IsInstallmentEligible')
}

const isZaamEnabled = () => {
	// check if zaam disabled from bussiness config:
	let flags = Storage.get("businessConfig");
	return flags?.enable_zaam;
}

const fetchZaamInstallmentTimeline = (sku='') => {
	let savedPlan = Storage.get("saved_plan");
	let product_code, plan_ids, number
	if(savedPlan){
		product_code = savedPlan.ProductCode;
		plan_ids = savedPlan.vmo_subplans_ids_sorted.join(',');
		let numberObj = Storage.get("number"); 
		number = numberObj?.MSISDN;
	}

	let config = {
		method: "get",
		url: "/payments/subscription_timeline",
        params: {
			number,
			plan_ids,
			product_code
		}
	};
	if(sku){
		config.params['sku'] = sku;
	}
	return HTTP(config);
}

const zaamPrices = (saved_plan, zaamPriceArr) => {
	if (!saved_plan) saved_plan = Storage.get("saved_plan");

	//plan price:
	let planPrice = saved_plan?.PackagePrice?.PlanNetPrice;
	let planPriceArr = [];
	let planPriceVatExc;
	if(planPrice){
		let vat = saved_plan.PackagePrice.VATPercentage;
		planPriceVatExc = exclude_vat(planPrice, vat);
		planPriceArr = [Helpers.formatNumber(planPrice), planPriceVatExc];
	}
	
	// let zaamPriceArr = Storage.get("zaam_installment_prices");
	let device_spec = saved_plan?.Plans?.find(p=> !Settings.types.includes(p.Type));
	let sku = device_spec?.ExtraDetails?.SKU;
	let deviceZaamPriceArr;
	if( zaamPriceArr && sku){
		deviceZaamPriceArr = zaamPriceArr?.find(item => item.SKU === sku);
	}
	let todayPayment = [], subscription = [];
	if(deviceZaamPriceArr){
		todayPayment = [Helpers.formatNumber(deviceZaamPriceArr.FirstPayment), Helpers.formatNumber(deviceZaamPriceArr.FirstPaymentVatExc)];
		subscription = [Helpers.formatNumber(deviceZaamPriceArr.SubscriptionPrice), Helpers.formatNumber(deviceZaamPriceArr.SubscriptionPriceVatExc)];
	}
	
	return {
		planPriceArr,
		subscription,
		todayPayment
	}
}

export {
    getInstallmentsDetails,
	checkInstalmentsEligibility,
	fetchZaamInstallmentTimeline,
	isZaamEnabled,
	zaamPrices
}